var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCareers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  fill: "#EAF0FD",
  fillOpacity: 0.75,
  rx: 3.931
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  stroke: "#2F64ED",
  rx: 3.931
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 21.154,
  height: 15.615,
  x: 7.423,
  y: 10.746,
  fill: "#EAF0FD",
  fillOpacity: 0.75,
  stroke: "#2F64ED",
  rx: 1.715
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F64ED",
  d: "M12.185 10.523v16.062m11.908-16.062v16.062m.554-19.108h-12.74"
})));
export { SvgCareers as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgcng9IjMuOTMwNzciIGZpbGw9IiNFQUYwRkQiIGZpbGwtb3BhY2l0eT0iMC43NSIvPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjM1IiByeD0iMy45MzA3NyIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxyZWN0IHg9IjcuNDIyODUiIHk9IjEwLjc0NjEiIHdpZHRoPSIyMS4xNTM4IiBoZWlnaHQ9IjE1LjYxNTQiIHJ4PSIxLjcxNTM4IiBmaWxsPSIjRUFGMEZEIiBmaWxsLW9wYWNpdHk9IjAuNzUiIHN0cm9rZT0iIzJGNjRFRCIvPgo8cGF0aCBkPSJNMTIuMTg0NiAxMC41MjMyVjI2LjU4NDciIHN0cm9rZT0iIzJGNjRFRCIvPgo8cGF0aCBkPSJNMjQuMDkyOCAxMC41MjMyVjI2LjU4NDciIHN0cm9rZT0iIzJGNjRFRCIvPgo8cGF0aCBkPSJNMjQuNjQ2NSA3LjQ3NjgxTDExLjkwOCA3LjQ3NjgxIiBzdHJva2U9IiMyRjY0RUQiLz4KPC9zdmc+Cg==";